module.exports = __webpack_public_path__ + "img/Pista_04.9f9764b6.png";